import { EnvironmentInjector, inject } from '@angular/core';

import { LazyComponentDetails } from '@core/shared/util';
import { ComponentPluginComponent } from '@mp/shared/component-plugins/util';
import { SupplierTransactionSettingsPermissions } from '@mp/transaction-management/supplier-settings/feature';
import { LoginContextService } from '@mpk/shared/data-access';
import type { PlatformSupplierDetailsTabPlugin, PlatformSupplierDetailsTabPluginInput } from '@mpsm/shared/util';

export function createPlatformSupplierTransactionSettingsTabPlugin(): PlatformSupplierDetailsTabPlugin {
  const loginContextService = inject(LoginContextService);

  return {
    label: 'Belegsteuerung',
    isEnabled: loginContextService.permission(SupplierTransactionSettingsPermissions.ViewSupplierTransactionSettings),
    async getComponentDetails(
      parentInjector: EnvironmentInjector,
    ): Promise<LazyComponentDetails<ComponentPluginComponent<PlatformSupplierDetailsTabPluginInput>>> {
      const { PlatformSupplierTransactionSettingsComponent } = await import('../components');

      return {
        component: PlatformSupplierTransactionSettingsComponent,
        environmentInjector: parentInjector,
      };
    },
  };
}
